import React from "react";
import PropTypes from "prop-types";

export function Wrapper(props) {
  return (
    <div
      className={props.className}
      tabIndex={props.tabIndex}
      aria-label={props.ariaLabel}
    >
      {props.children}
    </div>
  );
}

Wrapper.propTypes = {
  /**
   * classname for wrapper
   */
  className: PropTypes.string,
  /**
   * child components inside wrapper
   */
  children: PropTypes.arrayOf(PropTypes.element),
  /**
   *  tab index for if element is to be accessible by keyboard
   */
  tabIndex: PropTypes.number,
  /**
   * aria-label: string for labelling
   */
  ariaLabel: PropTypes.string,
};

Wrapper.defaultProps = {
  className: "",
  ariaLabel: undefined,
};
